/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_4_1 = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [33.889803338682725, -13.84774393439825],
                        [33.634371209776475, -13.84774393439825],
                        [33.634371209776475, -14.121590324002586],
                        [33.889803338682725, -14.121590324002586],
                        [33.889803338682725, -13.84774393439825]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_4_1